<template>
    <div>
        <template v-if="width < 2054 && width > 1699">
            <vs-row justify="flex-end">
                <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
            </vs-row>
        </template>
        <!-- begin:병동스케줄 화면 -->
        <div class="vx-col w-full lg:w-5/5 mb-base">
            <vx-card title="병동 스케줄" write-toggler @writeClick="popupOpen(now_date, '', -1)">
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/2 box-container">
                        <div>
                            <label for="now_date" class="vs-input--label"></label>
                            <datepicker name="uniquenaame" id="now_date" v-model="now_date" :locale="'ko'" placeholder="날짜선택" :format="customFormatter" @input="init(now_date, '')"></datepicker>
                        </div>
                        <!-- <div>
                            <vx-tooltip text="날짜적용" position="top">
                                <vs-button type="border" color="dark" icon-pack="feather" class="mt-7 ml-2" @click="init()">적용</vs-button>
                            </vx-tooltip>
                        </div> -->
                        <div>
                            <vx-tooltip text="날짜 초기화(오늘)" position="top">
                                <vs-button type="border" color="primary" icon-pack="feather" class="mt-7 ml-2" @click="init('', '')">오늘</vs-button>
                            </vx-tooltip>
                        </div>
                    </div>

                    <!-- <div class="vx-col w-full lg:w-1/2 text-right">
                        <vx-tooltip text="카톡보내기" position="top" style="display:inline-block;">
                            <vs-button color="warning" icon-pack="feather" @click="onClickKakao(0)">알림톡보내기</vs-button>
                        </vx-tooltip>
                    </div> -->
                </div>
                <vs-button type="line" v-for="(item, index) in tab_menu" :key="index" :class="activeMenu(item.MEDICAL_ROOM_SEQ, item.MEDICAL_ROOM_NM)" @click="init(now_date, item.MEDICAL_ROOM_SEQ)">
                    {{
                        item.MEDICAL_ROOM_NM
                    }}
                </vs-button>

                <div class="tb_wrap">
                    <div class="tb_box" style="width:100%;overflow-x:auto;height:auto;">
                        <table id="schedule" style="max-width:1200px; max-height:inherit;" class="border-collapse calendar">
                            <thead>
                                <tr class="fixed_top">
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" style="width:100px !important;">시간 / 환자</th>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" v-for="(item, index) in user_list" :key="index" style="width:150px;">
                                        {{ item }}<br />
                                        ({{ user_gender[index] }} - {{ user_age[index] }}세) <br />({{ ward_list[index] }})
                                        <!-- <div :key="index" @click="curePlan(item, index)" style="font-size:10px; ">
                                            <button>치료플랜{{ user_uid[index] }}</button>
                                        </div> -->
                                        <!-- <div :key="index" @click="memberReport(user_uid[index])" style="font-size:10px; ">
                                            <button class="round-btn">상세보기</button>
                                        </div> -->
                                        <vx-tooltip text="상세보기" position="bottom">
                                            <vs-button color="success" size="samll" type="line" icon-pack="feather" icon="icon-search" @click="memberReport(user_uid[index])" />
                                        </vx-tooltip>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in schedule_list" :key="index">
                                    <th
                                        class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                        style="width:100px !important;"
                                        :id="item.CODE_TIME.substring(0, 2) + ':' + item.CODE_TIME.substring(2, 4)"
                                    >
                                        {{ item.CODE_TIME.substring(0, 2) }}:{{ item.CODE_TIME.substring(2, 4) }}
                                    </th>
                                    <td
                                        class="border border-solid d-theme-border-grey-light"
                                        style="min-width:100px;height:50px;vertical-align:top;"
                                        v-for="(user_item, user_index) in item.PATIENT_USERNAME.split(',')"
                                        :key="user_index"
                                    >
                                        <div class="con-notifications-position">
                                            <span style="font-size:10px; ">{{ item.CODE_TIME.substring(0, 2) }}:{{ item.CODE_TIME.substring(2, 4) }} </span>
                                        </div>

                                        <template v-if="scheduleisShow(index, user_index)">
                                            <div @click="openModal(index, user_index)">
                                                <template v-if="item.MEDICAL_CODE.substring(0, 2) == '01'">
                                                    <vs-button type="gradient" color="danger" size="small">
                                                        {{ scheduleisShowText(index, user_index) }}
                                                    </vs-button>
                                                </template>
                                                <template v-else>
                                                    <template v-if="scheduleisShowText(index, user_index) === '고주파실'">
                                                        <vs-button type="gradient" color="danger" size="small"> {{ scheduleisShowText(index, user_index) }} </vs-button>
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="scheduleisShowText(index, user_index) === '침구실'">
                                                            <vs-button type="gradient" color="warning" size="small"> {{ scheduleisShowText(index, user_index) }} </vs-button>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="scheduleisShowText(index, user_index) === '물리치료실'">
                                                                <vs-button type="gradient" color="success" size="small"> {{ scheduleisShowText(index, user_index) }} </vs-button>
                                                            </template>
                                                            <template v-else>
                                                                <vs-button type="gradient" color="dark" size="small"> {{ scheduleisShowText(index, user_index) }} </vs-button>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </template>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <span
                                                ><vx-tooltip text="등록" position="top">
                                                    <vs-button
                                                        style="z-index:0;"
                                                        color="primary"
                                                        type="flat"
                                                        size="small"
                                                        icon-pack="feather"
                                                        icon="icon-edit-2"
                                                        @click="popupOpen(now_date, item.CODE_TIME, user_index)"
                                                    /> </vx-tooltip
                                            ></span>
                                        </template>

                                        <!-- <label style="width:100%; " v-else>
                                        <vs-checkbox v-model="check_array" :vs-value="item.PATIENT_UID.split(',')[user_index] + '_' + item.CODE_TIME"></vs-checkbox>
                                    </label> -->
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </vx-card>
        </div>
        <!-- end::병동스케줄 화면 -->
        <!-- begin::병동스케줄 수정팝업 -->
        <vs-popup title="병동스케줄 수정" :active.sync="popupFlag">
            <form @submit.prevent>
                <div class="vx-row">
                    <div class="vx-col w-full "><strong>환자명</strong> - {{ user_name }}</div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/2 ">
                        <label for="" class="vs-select--label">날짜</label>
                        <datepicker name="uniquename" :locale="'ko'" v-model="select_date" placeholder="날짜선택" :format="customFormatter"></datepicker>
                    </div>
                    <div class="vx-col w-full lg:w-1/2">
                        <!-- <vs-select class="w-auto" v-model="select_time" autocomplete label="시간" placeholder="시간">
                            <vs-select-item v-for="(item, index) in time_list" :key="index" :value="item.CODE_TIME" :text="item.TIME_NAME" />
                        </vs-select> -->
                        <label for="" class="vs-select--label">시간(hhmm)-ex.0930</label>
                        <input
                            type="text"
                            class="w-full vs-inputx vs-input--input normal hasValue"
                            id="select_time"
                            name="select_time"
                            label="시간을 입력해주세요."
                            placeholder="시간을 입력해주세요."
                            maxlength="4"
                            v-model="select_time"
                        />
                    </div>
                </div>
                <div class="vx-row pl-3 mt-6">
                    <div class="vx-col mt-3 w-full lg:w-1/3">
                        <ul class="leftx">
                            <li class="modelx mb-2">
                                <strong>치료실</strong>
                            </li>
                            <li v-for="(item, index) in room_arr1" :key="index">
                                <vs-radio class="mt-1" v-model="modify_medical_cd" vs-name="modify_medical_cd" :vs-value="item.MEDICAL_CD">{{ item.MEDICAL_NM }}</vs-radio>
                            </li>
                        </ul>
                    </div>

                    <div class="vx-col mt-3 w-full lg:w-1/3">
                        <ul class="leftx">
                            <li class="modelx mb-2">
                                <strong>원장실</strong>
                            </li>
                            <li v-for="(item, index) in room_arr2" :key="index">
                                <vs-radio class="mt-1" v-model="modify_medical_cd" vs-name="modify_medical_cd" :vs-value="item.MEDICAL_CD">{{ item.MEDICAL_NM }}</vs-radio>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-full text-right">
                        <vs-button color="danger" class="mb-2 mr-3" @click="detailDelete">삭제</vs-button>
                        <vs-button class="mr-3 mb-2" @click="modify">저장</vs-button>
                    </div>
                </div>
            </form>
        </vs-popup>
        <!-- end::병동스케줄 수정팝업 -->
        <!-- begin::병동스케줄 등록팝업 -->
        <vs-popup title="스케줄 등록" :active.sync="popupActive">
            <form @submit.prevent>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/2 ">
                        <label for="" class="vs-select--label">날짜</label>
                        <datepicker name="uniquename" :locale="'ko'" v-model="select_date" placeholder="날짜선택" :format="customFormatter"></datepicker>
                    </div>
                    <div class="vx-col w-full lg:w-1/2">
                        <!-- <vs-select class="w-auto" v-model="select_time" autocomplete label="시간" placeholder="시간">
                            <vs-select-item v-for="(item, index) in time_list" :key="index" :value="item.CODE_TIME" :text="item.TIME_NAME" />
                        </vs-select> -->
                        <label for="" class="vs-select--label">시간(hhmm)-ex.0930</label>
                        <input
                            type="text"
                            class="w-full vs-inputx vs-input--input normal hasValue"
                            id="select_time"
                            name="select_time"
                            label="시간을 입력해주세요."
                            placeholder="시간을 입력해주세요."
                            maxlength="4"
                            v-model="select_time"
                        />
                    </div>
                </div>

                <vs-divider color="danger">환자</vs-divider>
                <v-select :maxHeight="'50px'" v-model="select_user" multiple :closeOnSelect="false" :options="options" :dir="$vs.rtl ? 'rtl' : 'ltr'" placeholder="환자를 선택해주세요." />
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/1">
                        <vs-select class="w-auto" autocomplete v-model="select_medical_cd" label="치료실 / 원장실 / 기타" placeholder="스케줄 옵션">
                            <vs-select-item v-for="(item, index) in roomAll_arr" :key="index" :value="item.MEDICAL_CD" :text="item.MEDICAL_NM" />
                        </vs-select>
                    </div>
                </div>
                <div class="vx-row" style="margin-top:300px;">
                    <div class="vx-col w-full text-right">
                        <vs-button class="mr-3 mb-2" @click="calendarSave">저장</vs-button>
                        <vs-button color="warning" type="border" class="mb-2" @click="popupClose">닫기</vs-button>
                    </div>
                </div>
            </form>
        </vs-popup>
        <!-- end::병동스케줄 등록팝업 -->

        <vs-popup title="챠트보기" :active.sync="popupActive2">
            <div class="vx-row">
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <vx-card class="p-2">
                        <div class="text-center">
                            <p class="text-grey">#{{ chart_no }}</p>
                            <h4>{{ patientUsername }}({{ status_name }})</h4>
                            <p class="text-grey">{{ patientAge }}, {{ patientGender }}</p>
                            <p class="text-grey">{{ patient_phone }}</p>
                        </div>
                        <vs-divider></vs-divider>
                        <!-- <vs-avatar class="mx-auto my-6 block" size="80px" /> -->
                        <div class="flex justify-between text-center">
                            <span>
                                <p class="font-semibold">{{ medicalRoomNm }}({{ medicalRoomNumberNm }})</p>
                                <small class="text-grey">병동(호실)</small>
                            </span>
                            <span>
                                <p class="font-semibold">{{ medicalName }}</p>
                                <small class="text-grey">본 병원</small>
                            </span>
                            <span>
                                <p class="font-semibold">{{ sickNess }}</p>
                                <small class="text-grey">병명</small>
                            </span>
                        </div>
                        <vs-divider></vs-divider>
                        <div class="my-6">
                            <h5 class="mb-2">치료플랜</h5>
                            <p class="plan_text">
                                <template v-if="plan == null || plan == 0">작성한 치료플랜 없음</template>
                                <template v-else>{{ plan }}</template>
                            </p>
                        </div>
                        <vs-divider></vs-divider>
                        <table style="width:100%;" class="border-collapse calendar">
                            <colgroup>
                                <col width="40%" />
                                <col width="60%" />
                            </colgroup>

                            <tbody>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">최초입원일</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ in_init_date }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">입원일</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ in_date }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">퇴원예정일</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ out_date }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">왼퇴여부</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ complate_yn }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">식이</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ meal_name }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">보호자</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ protector_phone }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">주치의</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ medical_nm }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">협진의</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ west_medical_nm }}</td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="my-6">
                            <h5 class="mb-2">컴플레인</h5>
                            {{ memo }}
                        </div>

                        <!-- <vs-button type="gradient" class="w-full mt-6" color="#7367F0" gradient-color-secondary="#CE9FFC" @click="patientMemoSave">저장</vs-button> -->
                    </vx-card>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import dateClass from '@/../util/dateClass';
import Datepicker from 'vuejs-datepicker';
// import 'vue2-datepicker/index.css';
import vSelect from 'vue-select';
import moment from 'moment';

export default {
    components: {
        Datepicker,
        'v-select': vSelect,
    },
    data() {
        return {
            now_date: '',
            listType: '1',
            user_uid: [],
            user_list: [],
            user_plant: [],
            user_age: [],
            user_gender: [],
            schedule_list: [],
            ward_list: [],
            check_array: [],
            popupActive: false,
            popupFlag: false,
            user_name: '',
            useruid: '',
            schedule_info: '',
            room_arr1: [],
            room_arr2: [],
            roomAll_arr: [],
            modify_medical_cd: '',
            modify_schedule_seq: -1,
            mdofiy_uid: '',
            patient_member_list: [],
            time_list: [],
            select_medical_cd: '',
            select_date: '',
            select_time: '',
            select_user: '',
            options: [],
            tab_menu: [],
            bgcolor: '',
            medical_room_seq: '',
            medical_ward: '',
            popupActive2: false,
            patientUsername: '',
            patientUid: '',
            patientAge: '',
            patientGender: '',
            medicalRoomNm: '',
            medicalRoomNumberNm: '',
            medicalName: '',
            sickNess: '',
            plan: '',
            chart_no: '',
            status_name: '',
            patient_phone: '',
            in_init_date: '',
            in_date: '',
            out_date: '',
            complate_yn: '',
            meal_name: '',
            medical_nm: '',
            west_medical_nm: '',
            protector_phone: '',
            memo: '',
            width: window.innerWidth,
        };
    },
    methods: {
        handleResize(event) {
            this.width = window.innerWidth;
        },
        async init(date, medical_room_seq) {
            try {
                this.select_date = '';
                this.select_time = '';
                if (date == '') {
                    this.now_date = dateClass.getDate('YYYY-MM-DD');
                } else {
                    this.now_date = this.customFormatter(date);
                }

                if (medical_room_seq == '' || medical_room_seq == undefined) {
                    this.medical_room_seq = '0101';
                } else {
                    this.medical_room_seq = medical_room_seq;
                }
                let jsonData = {
                    now_date: this.now_date,
                    medical_room_seq: this.medical_room_seq,
                };
                // console.log(jsonData);
                const { data } = await axiosClass.get('/api/ward/list', jsonData, true);
                // console.log(data);
                setTimeout(() => {
                    this.$vs.loading.close('#schedule > .con-vs-loading');
                }, 100);
                this.user_list = data.data[0].PATIENT_USERNAME.split(',');
                this.user_uid = data.data[0].PATIENT_UID.split(',');
                this.user_plan = data.data[0].PLAN.split(',');
                this.user_age = data.data[0].PATIENT_AGE.split(',');
                this.user_gender = data.data[0].PATIENT_GENDER.split(',');
                this.ward_list = data.data[0].MEDICAL_ROOM_NM.split(',');
                this.room_arr1 = data.room1;
                this.room_arr2 = data.room2;
                this.schedule_list = data.data;
                this.tab_menu = data.tab_menu;
                this.roomAll_arr = data.roomAll;

                setTimeout(function() {
                    // location.href = '#' + dateClass.dateYYYYMMDD();
                    location.href = '#' + dateClass.nowhour() + ':00';
                }, 500);
            } catch (e) {
                console.log(e.response.data);
            }
        },

        onClickTab() {
            this.init(this.now_date);
        },
        async popupOpen(day, time, user_index) {
            // console.log(user_index);
            this.select_date = day;
            this.select_time = time;
            this.options = [];
            const { data } = await axiosClass.get('/api/cure/select', {}, true);

            this.time_list = data.timeList;
            this.popupActive = true;
            console.log('user_index:::', user_index);
            if (user_index > -1) {
                console.log('ok');
                this.select_user = [
                    {
                        id: this.user_uid[user_index],
                        label: this.medical_ward + '-' + this.ward_list[user_index] + ':' + this.user_list[user_index],
                    },
                ];
            } else {
                this.select_user = [];
                for (let i = 0; i < data.memberList.length; i++) {
                    this.options.push({
                        id: data.memberList[i].PATIENT_UID,
                        label: data.memberList[i].MEDICAL_ROOM_NM + '-' + data.memberList[i].MEDICAL_ROOM_NUMBER_NM + ':' + data.memberList[i].PATIENT_USERNAME,
                    });
                }
            }
            console.log('1', this.options);
        },

        async calendarSave() {
            let errorMsg = '';
            if (this.select_date == '') {
                errorMsg = '날짜를 선택하여 주십시오.';
            } else if (this.select_time == '') {
                errorMsg = '시간을 선택하여 주십시오.';
            } else if (this.select_user == '') {
                errorMsg = '환자를 선택하여 주십시오.';
            } else if (this.select_medical_cd == '') {
                errorMsg = '치료실/원장실/기타를 선택하여 주십시오.';
            }
            if (errorMsg != '') {
                this.$vs.notify({
                    title: 'Error',
                    text: errorMsg,
                    color: 'danger',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
                return;
            }

            const jsonData = {
                select_medical_cd: this.select_medical_cd,
                select_date: this.customFormatter(this.select_date),
                select_time: this.select_time,
                select_user: JSON.stringify(this.select_user),
                medical_room_seq: this.medical_room_seq,
            };
            // console.log(jsonData);
            this.$vs.loading({
                type: 'default',
                container: '#schedule',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });
            const { data } = await axiosClass.post('/api/ward/save', jsonData, true);
            // console.log(data);
            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);

            this.popupActive = false;

            this.date_list = data.cure_data[0].YMD.split(',');
            this.cure_data = data.cure_data;
            this.schedule_list = data.data;

            this.$vs.notify({
                title: 'Success',
                text: '정상적으로 등록되었습니다.',
                color: 'success',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });
        },
        popupClose() {
            this.popupActive = false;
        },
        //카톡보내기 클릭 처리
        onClickKakao(index) {
            this.$vs.notify({
                color: 'danger',
                title: '작업 대기',
                text: '작업 대기 중 입니다.',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });
        },
        scheduleisShow(index, user_index) {
            const temp = this.schedule_list[index].SCHEDULE_SEQ.split(',');
            if (temp[user_index] == '') {
                return false;
            } else {
                return true;
            }
        },
        async curePlan(item, index) {
            if (this.user_plan[index] == '') {
                this.user_plan[index] = '없음';
            }
            this.popupActive = false;
            let _this = this;
            _this.$vs.dialog({
                color: 'primary',
                title: item + '님 치료플랜',
                text: this.user_plan[index],
                acceptText: '닫기',
            });
        },
        scheduleisShowText(index, user_index) {
            const temp = this.schedule_list[index].MEDICAL_NM.split(',');
            // let text = this.user_list[user_index] + ' [' + this.schedule_list[index].CODE_TIME.substr(0, 2) + ':' + this.schedule_list[index].CODE_TIME.substr(2, 2) + '] - ' + temp[user_index];
            let text = temp[user_index];
            return text;
        },
        async openModal(index, user_index) {
            const { data } = await axiosClass.get('/api/cure/select', {}, true);

            this.time_list = data.timeList;
            this.select_time = this.schedule_list[index].CODE_TIME.substr(0, 2) + ':' + this.schedule_list[index].CODE_TIME.substr(2, 2);
            this.options = [];
            for (let i = 0; i < data.memberList.length; i++) {
                this.options.push({
                    id: data.memberList[i].PATIENT_UID,
                    label: data.memberList[i].MEDICAL_ROOM_NM + '-' + data.memberList[i].MEDICAL_ROOM_NUMBER_NM + ':' + data.memberList[i].PATIENT_USERNAME,
                });
            }

            this.popupFlag = true;
            this.user_name = this.user_list[user_index];
            this.useruid = this.user_uid[user_index];
            this.select_date = this.now_date;
            this.schedule_info = this.now_date + ' / ' + this.schedule_list[index].CODE_TIME.substr(0, 2) + ' : ' + this.schedule_list[index].CODE_TIME.substr(2, 2);
            this.modify_schedule_seq = this.schedule_list[index].SCHEDULE_SEQ.split(',')[user_index];
            this.modify_medical_cd = this.schedule_list[index].MEDICAL_CODE.split(',')[user_index];
            this.mdofiy_uid = this.user_list[user_index];
            console.log('2', this.options);
        },
        async modify() {
            const sendData = {
                mdofiy_uid: this.mdofiy_uid,
                modify_schedule_seq: this.modify_schedule_seq,
                modify_medical_cd: this.modify_medical_cd,
                modify_ymd_string: this.select_date,
                modify_time_string: this.select_time,
            };
            const { data } = await axiosClass.put('/api/ward/schedule', sendData, true);
            if (data.success) {
                this.$vs.notify({
                    title: 'Success',
                    text: '저장되었습니다.',
                    color: 'success',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
                this.popupFlag = false;
                this.init(this.now_date);
            }
            console.log('3', this.options);
        },

        async detailDelete() {
            const jsonData = {
                medical_room_seq: this.medical_room_seq,
                now_date: this.now_date,
            };
            const { data } = await axiosClass.delete('/api/ward/schedule/' + this.modify_schedule_seq, jsonData, true);
            this.schedule_list = data.data;
            this.popupFlag = false;

            this.$vs.notify({
                title: '알림',
                text: '삭제되었습니다.',
                color: 'danger',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });
        },
        customFormatter(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        activeMenu(medical_room_seq, medical_room_nm) {
            if (medical_room_seq == this.medical_room_seq) {
                if (medical_room_nm != undefined) {
                    this.medical_ward = medical_room_nm;
                    // console.log(this.medical_ward);
                }

                return 'activeMenu';
            } else {
                return '';
            }
        },

        async memberReport(uid) {
            const { data } = await axiosClass.get('/api/remote/userData/' + uid, {}, true);
            console.log(uid);
            console.log(data);
            this.popupActive2 = true;
            this.patientUsername = data.patientData.PATIENT_USERNAME;
            this.patientAge = data.patientData.PATIENT_AGE;
            this.patientGender = data.patientData.PATIENT_GENDER_CONVERT;
            this.medicalRoomNm = data.patientData.MEDICAL_ROOM_NM;
            this.medicalRoomNumberNm = data.patientData.MEDICAL_ROOM_NUMBER_NM;
            this.medicalName = data.patientData.MEDICAL_NAME;
            this.sickNess = data.patientData.SICKNESS;
            this.plan = data.patientData.PLAN;
            this.memo = data.patientData.MEMO;
            this.chart_no = data.patientData.CHART_NO;
            this.status_name = data.patientData.STATUS_NAME;
            this.patient_phone = data.patientData.PATIENT_PHONE;
            this.in_init_date = data.patientData.IN_INIT_DATE;
            this.in_date = data.patientData.IN_DATE;
            this.out_date = data.patientData.OUT_DATE;
            this.complate_yn = data.patientData.COMPLATE_YN;
            this.meal_name = data.patientData.MEAL_NAME;
            this.medical_nm = data.patientData.MEDICAL_NM;
            this.west_medical_nm = data.patientData.WEST_MEDICAL_NAME;
            this.protector_phone = data.patientData.PROTECTOR_PHONE;
            console.log(data);
        },
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.init('');
    },
    created() {
        this.listType = '0';
    },
    computed: {
        nowDate() {
            return this.now_date.substring(0, 4) + '년 ' + this.now_date.substring(4, 6) + '월';
        },
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>

<style>
.activeMenu {
    border-color: #015666;
}
.mt-7 {
    margin-top: 1.4rem !important;
}
.day {
    padding: 10px;
    display: flex;
    align-items: center;
}

.days_left {
    width: 50%;
    flex-direction: row;
    justify-content: center;
    font-size: 1.4rem;
    padding-left: 5px;
}

.days_right {
    width: 100%;
    text-align: right;
    flex-direction: row;
    padding-right: 5px;
}

.dayContents {
    padding: 10px;
    overflow: auto;
    min-height: 100px;
}

.calendar tr td {
    vertical-align: top;
}

.calendar tr td:hover {
    background-color: rgba(241, 241, 241, 0.2);
    cursor: pointer;
}

.includeIcon {
    display: initial;
}

.con-vs-chip {
    min-height: 40px;
}

.vs-chip--text {
    font-size: 1.1rem;
}

.calendar tbody tr td {
    padding: 10px;
}

.includeIcon {
    display: initial;
}

.con-vs-chip {
    min-height: 40px;
}

.vs-chip--text {
    font-size: 0.9rem;
}

.activeMenu {
    border-color: #015666;
}

.display-time {
    padding: 0.7rem;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
}
.box-container {
    display: flex;
}
/* table {
    width: 100%;
} */
table > thead > tr > th {
    font-weight: 400;
    background-color: blue;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    z-index: 1;
}
table > tbody > tr > td {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.tb_box {
    height: 750px;
    overflow: auto;
}
.table_header {
    position: sticky;
    top: 0;
}
/* .fixed_top {
    display: inline-table;
    position: absolute;
    top: 0;
    width: calc(100% - 17px);
    background: #eef7ff;
}
/*
.fixed_top th {
    border-top: 1px solid #dedede;
    border-bottom: 1px solid #dedede;
}
.tb tr.end {
    color: #999;
} */
.tb_box::-webkit-scrollbar {
  display: none;
}
/* .fixed_top {
    position: sticky;
    width: inherit;
    top: 5;
} */
.round-btn {
    border-radius: 8px;
    padding: 0.2rem;
    font-size: 0.4rem;
    border: 1px solid rgba(var(--vs-primary), 1);
    background: transparent !important;
    color: rgba(var(--vs-primary), 1);
    margin-top: 0.2rem;
}

</style>
